import React from 'react'

const FailedToLoadResourceMsg = () => {
  return <span className="font-italic text-danger">resource could not be loaded</span>
}

export default FailedToLoadResourceMsg
